import React from "react";
import { Link } from "react-router-dom";
import { Lock, Sparkles, Check } from "lucide-react";
import { MagneticButton } from "../MagneticButton";

/** Shown when a Free user tries to access /clients or /clients/:slug. */
export const Paywall = () => (
    <div className="pt-28 pb-16 mx-auto max-w-3xl px-5 md:px-10" data-testid="ipam-paywall">
        <div className="rounded-2xl border border-accent-cyan/20 bg-surface/60 backdrop-blur-md p-8 md:p-10 text-center shadow-glow-cyan/30">
            <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl border border-accent-cyan/30 bg-accent-cyan/[0.08] mb-5">
                <Lock className="w-5 h-5 text-accent-cyan" />
            </div>
            <p className="text-[10.5px] font-mono uppercase tracking-[0.32em] text-accent-cyan">Pro feature</p>
            <h1 className="mt-3 font-display font-semibold text-3xl sm:text-4xl tracking-tight" data-testid="paywall-title">
                Client Data Suite is a Pro feature
            </h1>
            <p className="mt-3 text-text-muted max-w-md mx-auto text-[13.5px] leading-relaxed">
                Track up to 10 client workspaces (15 as a Founding Member) with subnets, NIS2 scope,
                contacts, and (soon) hardware inventory. Reuse everything in ZeroConf.
            </p>
            <ul className="mt-6 grid gap-2 max-w-sm mx-auto text-left">
                {[
                    "Multi-tenant client folders",
                    "Subnet / VLAN registry",
                    "NIS2 scope tagging",
                    "ZeroConf wizard reuse (Phase 7c.4)",
                ].map((f) => (
                    <li key={f} className="flex items-center gap-2 text-[13px] text-text-muted">
                        <Check className="w-3.5 h-3.5 text-accent-cyan shrink-0" /> {f}
                    </li>
                ))}
            </ul>
            <div className="mt-7 flex items-center justify-center gap-3 flex-wrap">
                <Link
                    to="/pricing"
                    className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-accent-cyan text-canvas text-[13px] font-medium hover:shadow-glow-cyan"
                    data-testid="paywall-upgrade-btn"
                >
                    <Sparkles className="w-3.5 h-3.5" /> Upgrade to Pro
                </Link>
                <Link
                    to="/contact"
                    className="inline-flex items-center px-4 py-2.5 rounded-md border border-white/[0.08] text-[13px] text-text-muted hover:text-text-primary hover:border-accent-cyan/30"
                    data-testid="paywall-contact-btn"
                >
                    Talk to sales (MSP)
                </Link>
            </div>
        </div>
    </div>
);

export default Paywall;
